import { render, staticRenderFns } from "./ConsultCompaniesPage.vue?vue&type=template&id=45e3b96c"
import script from "./ConsultCompaniesPage.vue?vue&type=script&lang=ts"
export * from "./ConsultCompaniesPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultCompaniesPage.vue?vue&type=style&index=0&id=45e3b96c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports